import { USER_WAY_PROVIDER, USER_WAY_SERVICE_TYPE } from './UserWayIntegration.constants';

export function getUserWaySetting(providerServiceSettings = []) {
  return providerServiceSettings
    .map((pss, index) => ({ ...pss, globalIndex: index }))
    .find(
      ({ provider, serviceType }) =>
        provider === USER_WAY_PROVIDER && serviceType === USER_WAY_SERVICE_TYPE,
    );
}
